// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r3fB","type":"styles_type__hfmYx","choices":"styles_choices__3NDUX"};